import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 40px;
	padding: 40px 40px 0 40px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
`;

const StyledCategoriesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledCategoriesList = styled.div`
	display: flex;
	gap: 10px;
`;

const StyledCategory = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 0 10px;
	height: 30px;
	border-radius: 20px;
	border-width: 1px;
	border-style: solid;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledTransactionsList = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
	padding-bottom: 40px;
`;

const StyledTransactionsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export {
	StyledCategoriesContainer,
	StyledCategoriesList,
	StyledCategory,
	StyledContainer,
	StyledTransactionsContainer,
	StyledTransactionsList,
};
